export const ADD_COMMENT_ON_PROJECT = 'ADD_COMMENT_ON_PROJECT';
export const ADD_COMMENT_ON_SUBMISSION = 'ADD_COMMENT_ON_SUBMISSION';
export const ADD_COMMENT_REPLY = 'ADD_COMMENT_REPLY';
export const EDIT_PROJECT = 'EDIT_PROJECT';
export const EDIT_SUBMISSION = 'EDIT_SUBMISSION';
export const ADD_ASSIGNMENT_ON_CLASS = 'ADD_ASSIGNMENT_ON_CLASS';
export const ADD_SUBMISSION_ON_ASSIGNMENT = 'ADD_SUBMISSION_ON_ASSIGNMENT';
export const ADD_GROUP_ADMIN = 'ADD_GROUP_ADMIN';
export const ADD_GROUP_MEMBER = 'ADD_GROUP_MEMBER';
